import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

const staticTypes = [
  { name: 'Apartamento', image: '/tipos/apartamento.png', slugCATEGORIA: 'apartamento', codigoCATEGORIA: 28 },
  { name: 'Palácios / Castelos', image: '/tipos/castelo.png', slugCATEGORIA: 'palacios-e-castelos', codigoCATEGORIA: 71 },
  { name: 'Condomínio', image: '/tipos/condominio.png', slugCATEGORIA: 'condominio', codigoCATEGORIA: 6 },
  { name: 'Hotel', image: '/tipos/praiaPortugal.png', slugCATEGORIA: 'hotel', codigoCATEGORIA: 5 },
  { name: 'Casa', image: '/tipos/casa.png', slugCATEGORIA: 'casa', codigoCATEGORIA: 11 },
  { name: 'Studio', image: '/tipos/studio.png', slugCATEGORIA: 'studio', codigoCATEGORIA: 20 },
];

const PropertyTypes = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [types, setTypes] = useState(staticTypes);

  useEffect(() => {
    const load = async () => {
      try {
        const rawBase = import.meta.env.VITE_URL_API || '';
        const apiBase = rawBase.endsWith('/api') ? rawBase.slice(0, -4) : rawBase;
        const res = await fetch(`${apiBase}/api/categorias?ts=${Date.now()}`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          const normalizeUrl = (url) => {
            if (!url) return null;
            if (url.startsWith('http')) return url;
            return `${apiBase}${url}`;
          };
          const mapped = data.map((cat) => ({
            name: cat.nomeCATEGORIA || cat.nome || '',
            image: normalizeUrl(cat.imagemCATEGORIA) || '',
            slugCATEGORIA: cat.slugCATEGORIA || cat.slug || '',
            codigoCATEGORIA: cat.codigoCATEGORIA,
            destaque: Number(cat.destaqueCATEGORIA) === 1,
            ordem: cat.ordemCATEGORIA != null ? Number(cat.ordemCATEGORIA) : null,
            ativo: cat.ativoCATEGORIA !== 0,
          })).filter((c) => c.name && c.codigoCATEGORIA);

          // Cards da home = categorias marcadas como destaque no painel,
          // ordenadas por ordemCATEGORIA (fallback: slots estáticos antigos)
          const homeCats = mapped
            .filter((c) => c.destaque && c.ativo)
            .sort((a, b) => (a.ordem ?? 999) - (b.ordem ?? 999) || a.codigoCATEGORIA - b.codigoCATEGORIA);

          if (homeCats.length) {
            setTypes(homeCats.map((c, i) => ({
              ...c,
              image: c.image || staticTypes[i]?.image || '',
            })));
            return;
          }

          // Mantém apenas os tipos originais, na mesma ordem, mesclando imagem/dados da API
          const merged = staticTypes.map((st) => {
            // 1º) casa pelo código (fonte da verdade para o card)
            // 2º) casa pelo slug exato ou por prefixo (ex.: 'apartamento' casa com 'apartamentos-15')
            const found = mapped.find((m) => m.codigoCATEGORIA === st.codigoCATEGORIA)
              || mapped.find((m) =>
                m.slugCATEGORIA &&
                (m.slugCATEGORIA === st.slugCATEGORIA || m.slugCATEGORIA.startsWith(st.slugCATEGORIA))
              );
            if (found) {
              return {
                ...st,
                ...found,
                codigoCATEGORIA: found?.codigoCATEGORIA ?? st.codigoCATEGORIA,
                image: found.image || st.image,
              };
            }
            return st;
          });

          setTypes(merged);
        }
      } catch (err) {
        console.warn('[PropertyTypes] usando fallback estático, erro ao carregar categorias:', err.message);
      }
    };
    load();
  }, []);

  const handleCategoryClick = (codigoCATEGORIA, slugCATEGORIA) => {
    navigate(`/category/${codigoCATEGORIA}/${slugCATEGORIA}`);
  };

  return (
    <section className="property-types">
      <div className="container">
        <h2>{t('propertyTypes.title')}</h2>
        <p>{t('popularDestinations.subtitle')}</p>
        <div className="orange-line"></div>
        
        <div className="types-grid">
          {types.map((type, index) => (
            <div 
              key={index} 
              className="type-card" 
              onClick={() => handleCategoryClick(type.codigoCATEGORIA, type.slugCATEGORIA)}
            >
              <img src={type.image} alt={type.name} />
              <div className="type-overlay"></div>
              <h3>{type.name}</h3>
            </div>
          ))}
        </div>

        <div className="premium-banner">
          <h3>{t('premium.title')}</h3>
          <button
            type="button"
            className="premium-button"
            onClick={() => navigate('/category/imoveis-de-luxo')}
            aria-label="Ver imóveis premium"
          >
            {t('premium.button')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default PropertyTypes;